import { Controller } from "stimulus";
import AjaxLoader from "../../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', () => {
      this.submit();
    });
  }

  submit(ev) {
    AjaxLoader.show();
    let option = this.element.selectedOptions[0];
    let frameElement = undefined;

    if (!option.dataset.turboFrame || option.dataset.turboFrame === '_top')
      Turbo.visit(option.dataset.url);

    switch (option.dataset.turboFrame) {
      case '_self':
        frameElement = this.element.closest('turbo-frame');
        break;
      default:
        frameElement = document.querySelector(this.element.dataset.turboFrame);
        break
    }

    frameElement.src = option.dataset.url;
    AjaxLoader.hide();
  }
};